import { baseApi } from 'project/api';
import { notificationService } from 'project/services';
import { notificationTypes } from 'project/general';
import { getApiUrlByName } from 'project/helpers';
import { apiNames } from 'project/general';

const SET_CMS_COOKIE_LEVEL_PATH = getApiUrlByName(apiNames.SET_CMS_COOKIE_LEVEL);

const cookieLevels = Object.freeze({
    NECESSARY: -100,
    FUNCTIONAL: 0,
    ANALYTICS: 200,
    THIRD_PARTY: 1000
});

export class CookieService {

    static setCmsCookieLevel = (cookieLevel) => {

        const config = { headers: { 'Content-Type': 'application/json' } };

        baseApi.post(SET_CMS_COOKIE_LEVEL_PATH, cookieLevel, config)
            .then((result) => {
                const data = result.data.data;
                this.setLocalStorage(data);
            }).catch((err) => {
                console.error(err);
                return null;
            });
        

        notificationService.push({
            message: 'Cookie settings saved',
            type: notificationTypes.SUCCESS,
        });

    }

    static setLocalStorage = (cookieLevel) => {
        localStorage.setItem('necessary_cookies', cookieLevel >= cookieLevels.NECESSARY);
        localStorage.setItem('functional_cookies', cookieLevel >= cookieLevels.FUNCTIONAL);
        localStorage.setItem('analytics_cookies', cookieLevel >= cookieLevels.ANALYTICS);
        localStorage.setItem('third-party_cookies', cookieLevel >= cookieLevels.THIRD_PARTY);
    }

}
